export enum Suffix {
	None = -1,
	Mr = 0,
	Mrs = 1,
	Ms = 2,
	Dr = 3,
}

export const SuffixNames = {
	[Suffix.None]: '-',
	[Suffix.Mr]: 'Mr.',
	[Suffix.Mrs]: 'Mrs.',
	[Suffix.Ms]: 'Ms.',
	[Suffix.Dr]: 'Dr.',
};
